import React, { useState, useReducer, useCallback } from 'react';
import Input from '../common/Input';
import { useSelector } from 'react-redux';
import {
    useGoogleReCaptcha, GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import Loading from '../svg/Loading';
import Button from '../common/button/Button';
import axios from 'axios';
import CloseIcon from '../ui/svgs/CloseIcon';

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';
const FORM_INPUT_RESET = 'FORM_INPUT_RESET';

const formReducer = (state, action) => {

    if (action.type === FORM_INPUT_UPDATE) {
        const updatedValues = {
            ...state.inputVal,
            [action.input]: action.value
        }
        const updatedValidities = {
            ...state.inputValidities,
            [action.input]: action.isValid
        }
        let updatedFormIsValid = true;
        for (const key in updatedValidities) {
            updatedFormIsValid = updatedFormIsValid && updatedValidities[key]
        }
        return {
            inputVal: updatedValues,
            inputValidities: updatedValidities,
            formIsValid: updatedFormIsValid
        }
    }
    else if (action.type === FORM_INPUT_RESET) {
        return {
            inputVal: {
                name: '',
                email: '',
                subject: '',
                message: ''
            },
            inputValidities: {
                name: false,
                email: false,
                subject: false,
                message: false
            },
            formIsValid: false
        }
    }
    return state;
}

export default function ContactForm(props) {

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [token, setToken] = useState('');
    const [dynamicAction, setDynamicAction] = useState('homepage');



    const [isLoading, setIsLoading] = useState(false);
    const [isMessageSent, setIsMassageSent] = useState(false);
    const [isSubmitPressed, setIsSubmitPresses] = useState(false);
    const [isError, setIsError] = useState("");
    const stateData = useSelector(state => state.app);
    const {ip, country } = stateData;

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputVal: {
            name: '',
            email: '',
            subject: '',
            message: '',
        },
        inputValidities: {
            name: false,
            email: false,
            subject: false,
            message: false,
        },
        formIsValid: false
    })

    const onChangeInputHandler = useCallback((inputIdentifier, inputValue, inputValidty) => {
        dispatchFormState({
            type: FORM_INPUT_UPDATE,
            value: inputValue,
            isValid: inputValidty,
            input: inputIdentifier
        });
    }, [dispatchFormState])

    const onSubmitHandler = async (event) => {
        event.preventDefault();
        setIsSubmitPresses(true);
        if (!formState.formIsValid) {
            return;
        }
        const resultC = await executeRecaptcha('dynamicAction');
        setToken(resultC);
        setIsLoading(true);

        try {
            const res = await axios.post(`${process.env.isApiserver}/contacts/create`,  {
                name: formState.inputVal.name,
                email: formState.inputVal.email,
                subject: formState.inputVal.subject,
                message: formState.inputVal.message,
                ip:ip,
                captcha: resultC,
                country: country ? country: "Turkey"
            });

            setIsLoading(false);
            if (res.data.retcode === -10) {
                props.locale === 'tr' ? 
                setIsError(" (Email)"):
                setIsError(" (Incorrect Email)");
            }
            if (res.data.retcode === -1 || res.data.retcode === -50 || res.data.retcode === -20) {
                setIsError('...');
            }
            if (res.data.retcode === -100) {
                setIsError(`${res.data.error.message}`);
            }
            if (res.data.retcode === 200) {
                dispatchFormState({
                    type: FORM_INPUT_RESET
                });
                setIsMassageSent(true);
                setIsSubmitPresses(false);
            }

        }
        catch (err) {
            setIsLoading(false);
            setIsMassageSent(false);
        }
    }

    const handleReCaptchaVerify = useCallback(
        token => {
            setToken(token);
        },
        [setToken]
    );

    return (

        <div className="col-12">
            <p className="mb-4 mt-1 text-5 text-color-secondary line-height-2"> {props.datas.questionTitle}  </p>
            <form className="contact-form" onSubmit={onSubmitHandler} id="demo-form">
                {!isLoading && isMessageSent &&
                    <div className="contact-form-success alert alert-success mt-4 d-flex align-items-center justify-content-between">
                        {props.datas.successMessage}
                        <button className="btn" 
                            onClick={() => setIsMassageSent(false)}>
                            <CloseIcon fill="#ff6600" width="1em"/>
                        </button>         
                    </div>}
                {!isMessageSent && isError !== '' &&
                    <div className="contact-form-error alert alert-danger mt-4 d-flex align-items-center justify-content-between">
                        {props.datas.errorMessage}
                        {isError}
                        <button className="btn"
                            onClick={() => {1
                                setIsMassageSent(false)
                                setIsError('')
                            }}>
                            <CloseIcon fill="#ff6600" width="1em"/>
                        </button>
                    </div>
                }
                {isLoading && <div className="d-flex align-items-center"
                    style={{ margin: "0 auto" }}> <Loading /> </div>}
                {!isMessageSent &&
                    <>
                        <div className="row">
                            <div className="col-md-6 h-100 form_input">
                                <div className="form-row">
                                    <Input
                                        name="name"
                                        type="text"
                                        placeholder={props.datas.placeHolderOne}
                                        onChangeInput={onChangeInputHandler}
                                        required
                                        initvalue={formState.inputVal.name}
                                        completed={`${isMessageSent}`}
                                        press={isSubmitPressed.toString()}
                                    />
                                </div>
                                <div className="form-row">
                                    <Input
                                        name="email"
                                        type="email"
                                        email="true"
                                        placeholder={props.datas.placeHolderTwo}
                                        onChangeInput={onChangeInputHandler}
                                        required
                                        initvalue={formState.inputVal.email}
                                        completed={`${isMessageSent}`}
                                        press={isSubmitPressed.toString()}
                                    />
                                </div>
                                <div className="form-row">
                                    <Input
                                        name="subject"
                                        type="text"
                                        placeholder={props.datas.placeHolderThree}
                                        onChangeInput={onChangeInputHandler}
                                        required
                                        initvalue={formState.inputVal.subject}
                                        min={3}
                                        completed={`${isMessageSent}`}
                                        press={isSubmitPressed.toString()}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6" style={{ minHeight: "100%" }} >
                                <div className="form-row h-100">
                                    <Input
                                        name="message"
                                        type="textarea"
                                        placeholder={props.datas.placeHolderFour}
                                        onChangeInput={onChangeInputHandler}
                                        required
                                        initvalue={formState.inputVal.message}
                                        min={10}
                                        completed={`${isMessageSent}`}
                                        press={isSubmitPressed.toString()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row my-3">
                            <div className="col-12 d-flex"
                                style={{ justifyContent: "flex-end", alignItems: "center" }} >
                                <Button type="submit" title={props.datas.buttonName} />
                            </div>
                        </div>
                    </>
                }
                <GoogleReCaptcha
                    action={dynamicAction}
                    onVerify={handleReCaptchaVerify}
                />
            </form>

        </div>


    )
}
